import { render, staticRenderFns } from "./mainFinances.vue?vue&type=template&id=28649076&"
import script from "./mainFinances.vue?vue&type=script&lang=js&"
export * from "./mainFinances.vue?vue&type=script&lang=js&"
import style0 from "./mainFinances.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports